<!-- 单独对外实时视频组件 -->
<template>
  <div class="video-box">
    <div class="err-tip" v-if="showErr">
      <el-alert title="设备不在线！" type="error" close-text="知道了"> </el-alert>
    </div>

    <el-button type="primary" size="mini" id="openBtn" @click="openVedio" class="video-btn">连接</el-button>
    <RealVideoPlayRtc
      v-if="isShowRealvideo && rtcType === 'trtc'"
      :helmetId="device.serialNumber"
      :userId="userId"
      :userName="device.userName"
      id="RealVideo"
    ></RealVideoPlayRtc>
    <RealVideoPlaySRS
      v-else-if="isShowRealvideo && rtcType === 'srs'"
      :helmetId="device.serialNumber"
      :userId="device.userId"
      :currentItem="device"
      id="RealVideo"
    ></RealVideoPlaySRS>
    <RealVideoMediasoup
      v-else-if="isShowRealvideo && rtcType === 'mediasoup'"
      :helmetId="device.serialNumber"
      :userId="device.userId"
      :currentItem="device"
      id="RealVideo"
    ></RealVideoMediasoup>
  </div>
</template>

<script>
import { delSession, setSession, nowDateTime } from '@/api/common'
import { getLogin, getRecordFlag } from '@/api/login'
import { creatGK3Socket } from '@/common/websocket/index'

import { gethelmet } from '@/api/helmetManage'
import { loginStorage } from '@/common/loginStorage'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
import { loginMVCP } from '@/common/rtc/mediasoup/mediasoup-frame'
import { registerAlone } from '@/common/rtc/srs/video-frame'
import RealVideoPlayRtc from '@/components/realVideoFrame/RealVideoCompnentRTC.vue'

import RealVideoMediasoup from '@/components/realVideoFrame/RealVideoCompnent.vue'
import RealVideoPlaySRS from '@/components/realVideoFrame/RealVideoCompnentSRS.vue'

export default {
  name: 'RealVideo',
  components: { RealVideoPlayRtc, RealVideoPlaySRS, RealVideoMediasoup },
  data() {
    return {
      // 显示视频组件
      isShowRealvideo: false,
      // 设备参数
      device: {
        serialNumber: null,
        userId: '',
        userName: '',
      },
      // 视频分辨率
      resolutionP: 12,
      // 显示 设备不在线 提示
      showErr: false,
      // 账户名
      userName: '',
      // 登录密码
      password: '',
      // 当前时间 yy-mm-nn
      timestamp: '',
      // 用户id
      userId: '',
      mediaServe: '',
    }
  },
  mounted() {
    this.username = this.getQueryVariable('appKey')
    let secretKey = this.getQueryVariable('secretKey')
    this.timestamp = nowDateTime()
    let passKey = secretKey + '.' + this.username + '.' + this.timestamp + '.' + secretKey
    this.password = md5(passKey)

    // 判断地址上的 参数是否有ID
    let helmetId = this.getQueryVariable('id')
    this.userId = null
    if (this.getQueryVariable('userid')) {
      this.userId = this.getQueryVariable('userid')
    }
    if (!helmetId) {
      console.log('未传入安全帽id')
      return
    }
    if (!this.username || !secretKey) {
      delSession('access_token')
      delSession('expireTime')
      delSession('HWSecurity_access_token')
      delSession('userId')
      sessionStorage.removeItem('featureCode')
      sessionStorage.removeItem('isAdmin')
    }
    this.device = {
      serialNumber: helmetId,
      userId: this.userId,
      userName: '',
    }
    this.login()
  },
  computed: {
    ...mapGetters(['rtcType', 'isCloud']),
    helmetStatus() {
      return this.$store.state.helmetStatusObj[this.device.serialNumber]
    },
    handleresolutionP() {
      return this.$store.state.handleresolutionP
    },
  },
  methods: {
    // 获取地址栏参数
    getQueryVariable(name) {
      try {
        var url = window.location.href
        if (url.indexOf('?') === -1) {
          return ''
        }
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = url.split('?')[1].match(reg)
        if (r != null) {
          return r[2]
        }
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      } catch (e) {
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      }
    },
    // 请求登录接口、登录成功后连接websocket服务
    login() {
      let params = {
        data: {
          username: this.username,
          password: this.password,
          grant_type: 'password',
          auth_type: 'ak_sk',
          timestamp: this.timestamp,
        },
      }
      getLogin(params).then(val => {
        let state = val.state
        let res = val
        if (state === 0) {
          this.getDeviceInfo()
          if (!this.isCloud) {
            this.getCloudRoomUrl()
          }
          this.loginErrorHint = ''
          this.$store.dispatch('alterName', res.username)
          // 参数储存
          loginStorage(res)
          // createSocket()
          creatGK3Socket()
          if (localStorage.getItem('theme') === null) {
            localStorage.setItem('theme', 'default')
          }
          console.log('登录成功')
        } else {
          console.log('登录失败')
          this.$notify({
            title: '提示',
            message: ' 密钥无效，请重新获取',
            duration: 0,
          })
        }
      })
    },
    getCloudRoomUrl() {
      if (this.rtcType === 'srs') {
        //  连接注册新媒体平台 服务
        registerAlone()
      } else if (this.rtcType === 'mediasoup') {
        // 连接mediasoup
        loginMVCP()
      }
    },
    // 获取列表
    getDeviceInfo() {
      let params = {
        serialNumber: this.device.serialNumber,
        specModel: '',
        status: '',
        binded: '',
        pageNum: 1,
        pageSize: 10,
        specType: '',
      }
      gethelmet(params).then(res => {
        if (res.state === 0) {
          let helmetUser = res.data.list
          if (helmetUser && helmetUser[0]) {
            if (helmetUser[0].onlineStatus === 0) {
              // 提示设备不在线
              this.showErr = true
            }
            this.device = helmetUser[0]
            if (helmetUser[0].userId) {
              // 用地址上的userid 与获取数据的id比较
              if (this.userId !== '' && this.userId) {
                if (this.device.userId !== helmetUser[0].userId) {
                  this.$notify({
                    title: '提示',
                    message: '设备序列号与用户ID不匹配',
                    duration: 0,
                    position: 'bottom-right',
                  })
                }
              } else {
                this.userId = helmetUser[0].userId
              }
            } else {
              this.$notify({
                title: '提示',
                message: '该设备未绑定用户',
                duration: 0,
                position: 'bottom-right',
              })
              return
            }
            this.device.userName = helmetUser[0].userName
          } else {
            this.$notify({
              title: '提示',
              message: '无该设备序列号',
              duration: 0,
            })
            return
          }
          this._getRecordFlag()
        }
      })
    },
    _getRecordFlag() {
      getRecordFlag().then(res => {
        if (res.state === 0) {
          let data = res.data
          data.forEach(element => {
            if (element.transcribe === 'TRANSCRIBE_REAL_VIDEO') {
              setSession('TRANSCRIBE_REAL_VIDEO', element.value)
            } else if (element.transcribe === 'TRANSCRIBE_LIVE') {
              setSession('TRANSCRIBE_LIVE', element.value)
            } else if (element.transcribe === 'TRANSCRIBE_LIVE_MODE') {
              this.$store.commit('changeLiveMode', element.value)
            }
          })
        }
        // 点击打开实时视频
        document.getElementById('openBtn').click()
      })
    },
    openVedio() {
      this.isShowRealvideo = true
      // document.getElementById('RealVideo').start()
    },
  },
}
</script>
<style scoped>
.video-box {
  position: relative;
  height: 100%;
  background-color: #fff;
}
.video-btn {
  position: absolute;
  display: none;
}
.err-tip {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 9999;
}
.show-video {
  height: 100%;
  width: 100%;
}
</style>
